import {
  flexRender,
} from '@tanstack/react-table';

const index = ({ table, w = "88%" }) => {
  return (
    <div className={`w-[${w}] h-[90%] border-2 border-gray-600 shadow-lg rounded-b-lg -mt-2 flex flex-col`}>
      <div className="flex-1 w-full overflow-auto">
        <div className="w-full overflow-x-auto">
          <table className='w-full min-w-max'>
            <thead className='text-[#888888] text-sm font-semibold border-b-2 border-[#a2a2a2]'>
              {table.getHeaderGroups().map(headerGroup => (
                <tr key={headerGroup.id} className='h-12'>
                  {headerGroup.headers.map(header => (
                    <th
                      key={header.id}
                      className="whitespace-nowrap px-2 py-1 text-left"
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map(row => (
                <tr
                  key={row.id}
                  className='h-12 text-xs border-b border-[#a2a2a2] text-gray-700 font-semibold text-center'
                >
                  {row.getVisibleCells().map(cell => (
                    <td
                      key={cell.id}
                      className="whitespace-nowrap px-2 py-1 text-ellipsis overflow-hidden"
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex items-center justify-center gap-8 mt-auto mb-4">
        <button
          className="px-3 py-1 text-sm bg-gray-200 rounded disabled:opacity-50"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          Anterior
        </button>
        <span className="text-sm">
          Página{" "}
          <strong>
            {table.getState().pagination.pageIndex + 1} de{" "}
            {table.getPageCount()}
          </strong>
        </span>
        <button
          className="px-3 py-1 text-sm bg-gray-200 rounded disabled:opacity-50"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          Siguiente
        </button>
      </div>
    </div>
  )
}

export default index